import { createStore } from 'vuex'
import createPersistedState from 'vuex-persistedstate'

// Dados que permanecem até ser atualizado
// Não estando no dataState a store é limpa após refresh
const dataState = createPersistedState({
  paths: ['user', 'pedidoAberto'],
})

export default createStore({
  state: {
    sidebarVisible: '',
    sidebarUnfoldable: false,
    user: {},
    produtosImportacaoPedido: [],
    produtosMultiplosPedidos: [],
    listaMultiplosPedidos: [],
    campanhaNovoPedido: {},
    pedidoAberto: {},

    hiperfarmaPedidoUsuario: {},

    filtros: {},
  },
  plugins: [dataState],
  mutations: {
    toggleSidebar(state) {
      state.sidebarVisible = !state.sidebarVisible
    },
    toggleUnfoldable(state) {
      state.sidebarUnfoldable = !state.sidebarUnfoldable
    },
    updateSidebarVisible(state, payload) {
      state.sidebarVisible = payload.value
    },
    setUser(state, payload) {
      state.user = payload.value
    },
    setPedidoAberto(state, payload) {
      state.pedidoAberto = payload.value
    },
    setProdutosMultiplosPedidos(state, payload) {
      state.produtosMultiplosPedidos = payload.value
    },
    setMultiplosPedidos(state, payload) {
      state.listaMultiplosPedidos = payload.value
    },
    setCampanhaNovoPedido(state, payload) {
      state.campanhaNovoPedido = payload.value
    },
    setProdutosImportacaoPedido(state, payload) {
      state.produtosImportacaoPedido = payload.value
    },

    setHiperfarmaPedidoUsuario(state, payload) {
      state.hiperfarmaPedidoUsuario = payload.value
    },

    setFiltros(state, value) {
      state.filtros = value
    },
  },
  getters: {
    user(state) {
      return state.user
    },
    produtosMultiplosPedidos(state) {
      return state.produtosMultiplosPedidos
    },
    multiplosPedidos(state) {
      return state.listaMultiplosPedidos
    },
    campanhaNovoPedido(state) {
      return state.campanhaNovoPedido
    },
    produtosImportacaoPedido(state) {
      return state.produtosImportacaoPedido
    },

    hiperfarmaPedidoUsuario(state) {
      return state.hiperfarmaPedidoUsuario
    },

    filtros(state) {
      return state.filtros
    },
  },
  actions: {},
  modules: {},
})
